<template>
  <div
    class="dropdown-wrapper enext-input"
    :class="[
      rules && rules.length ? 'enext-input--validable' : '',
      errorMessage ? 'invalid': '',
      $attrs?.class ? $attrs.class : ''
    ]"
  >
    <kendo-combobox
      class="dropdown"
      :class="cssClasses"
      v-bind="customAttrs"
      @filterchange="filterChange"
      @open="onOpen"
      @close="onClose"
      :icon-class-name="iconClassName"
      :data-items="items"
    >
      <template
        v-for="(_, slot) of $slots"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
    </kendo-combobox>
    <ErrorMessage
      :error-message="errorMessage"
      class="enext-input__errormessage"
    />
  </div>
</template>

<script>
import {ComboBox} from '@progress/kendo-vue-dropdowns'
import {useDropdown} from '~/composables/useDropdown'
import ErrorMessage from '~/components/input-components/ErrorMessage'

// Create a wrapped ComboBox component with null-safe mounted hook
const WrappedComboBox = {
  extends: ComboBox,
  mounted() {
    try {
      // Override the mounted logic with null checks
      this.hasMounted = true

      // Safe access to inputRef - handles null case
      let input = this.inputRef?.input || null

      // Fallback to DOM query if refs fail
      if (!input) {
        input = this.$el?.querySelector('input.k-input-inner')
      }

      this.input = input

      // Call base methods if they exist
      if (this.base) {
        const getRef = (component, refName, guid) => {
          return component[refName] || component.$refs?.[guid] || null
        }

        this.base.wrapper = getRef(this, 'kendoAnchor', this.anchor)
        this.element = getRef(this, 'kendoAnchor', this.anchor)

        if (this.base.didMount) {
          this.base.didMount()
        }
      }

      if (this.setValidity) {
        this.setValidity()
      }
    } catch (error) {
      // Silently handle mount errors to prevent component breakage
      this.hasMounted = true
    }
  }
}

export default {
  name: 'ComboBoxDropDown',
  components: {
    ErrorMessage,
    'kendo-combobox': WrappedComboBox
  },
  props: {
    iconClassName: {
      type: String,
      default() {
        return 'k-i-arrow-chevron-down'
      }
    },
    rules: {
      type: Array,
      required: false,
      default() {
        return []
      }
    }
  },
  setup(props, {attrs}) {
    const dropdown = useDropdown({
      getDataItems: () => attrs['data-items'],
      getAttrs: () => attrs,
      rules: props.rules
    })

    return {
      ...dropdown
    }
  },
  computed: {
    customAttrs() {
      let attrs = {...this.$attrs, class: ''}
      return attrs
    }
  }
}
</script>
